import styled, { css } from 'styled-components';

export const MainContentContainer = styled.main`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  position: relative;
  overflow-y: auto;
  height: 100vh;
  padding: 0 ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[4]};

  @media (max-width: 767px) {
    height: auto;
    padding: 0 ${({ theme }) => theme.spacing[3]} ${({ theme }) => theme.spacing[3]};
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 0 ${({ theme }) => theme.spacing[6]} ${({ theme }) => theme.spacing[4]};
  }

  /* When the messages page is active, allow it to fill the height naturally */
  ${({ $isMessagesRoute }) =>
    $isMessagesRoute &&
    css`
      overflow-y: hidden;
      padding-bottom: 0;

      @media (max-width: 767px) {
        height: 100vh;
        padding-bottom: 0;
      }
    `}
`;
